import React, { memo } from 'react';
import PropTypes from 'prop-types';

const MapComponents = ({ children }) => (
  <div>
    {children}
  </div>
);

MapComponents.propTypes = {
  children: PropTypes.node
};

export default memo(MapComponents);
